import { Component, Input } from '@angular/core';

import { SearchActivityEvents } from 'generated/graphql';

@Component({
  selector: 'app-export-event',
  templateUrl: './export-event.component.html'
})

export class ASExportEventComponent {
  @Input() item: SearchActivityEvents.Node;

  formatExportTitle(title: string) {
    return title.replace('_', ' ');
  }
}
